import React, { useMemo } from 'react';
import {
  FaBullhorn,
  FaCog,
  FaCreditCard,
  FaCrown,
  FaGlobe,
  FaHome,
  FaMailBulk,
  FaMoneyBill,
  FaShoppingCart,
  FaTelegram,
  FaUser,
  FaUserFriends,
} from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'app/shared/i18n';

export const AuthMenu = props => {
  const { t } = useTranslation();
  const menu = useMemo(() => {
    if (props.isAdmin) {
      return [
        { title: 'Trang chủ', path: '/', icon: <FaHome /> },
        { title: 'Quản lý user', path: '/admin/users', icon: <FaUserFriends /> },
        { title: 'Quản lý ngân hàng', path: '/admin/banks', icon: <FaCreditCard /> },
        { title: 'Quản lý nạp tiền', path: '/admin/deposit', icon: <FaMoneyBill /> },
        { title: 'Quản lý đơn hàng', path: '/admin/order', icon: <FaShoppingCart /> },
        { title: 'Quản lý mail', path: '/admin/mails', icon: <FaMailBulk /> },
        { title: 'Quản lý ranking', path: '/admin/ranks', icon: <FaCrown /> },
        { title: 'Cài đặt hệ thống', path: '/admin/system-settings', icon: <FaCog /> },
        { title: 'Quản lý thông báo', path: '/admin/announcements', icon: <FaBullhorn /> },
        { title: 'Quản lý proxy', path: '/admin/proxies', icon: <FaGlobe /> },
        { title: 'Site 2 (Telegram)', path: '/admin/site2', icon: <FaTelegram /> },
      ];
    } else {
      return [
        { title: t('menu.home'), path: '/', icon: <FaHome /> },
        { title: t('menu.profile'), path: '/profile', icon: <FaUser /> },
        { title: t('menu.deposit'), path: '/deposit', icon: <FaMoneyBill /> },
        { title: t('menu.orderHistory'), path: '/order', icon: <FaShoppingCart /> },
      ];
    }
  }, [props.isAdmin, t]);

  return (
    <div className="ms-authmenu">
      <div className="ms-authmenu__inner">
        {menu.map(item => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) => `ms-authmenu__item ${isActive ? 'active' : ''}`}
          >
            {item.icon} {item.title}
          </NavLink>
        ))}
      </div>
    </div>
  );
};
